export default "__VITE_ASSET__wXqhR9mb__"